import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { our_value_image } from '../../../all_constant';

import iconvalues from "../../../assets/images/icon-values.png";
import iconmission from "../../../assets/images/icon-our-mission.png";
import iconquality from "../../../assets/images/icon-quality.png";
import iconvision from "../../../assets/images/icon-our-vision.png";

import { connect } from 'react-redux';
import { getValues } from '../../../redux/actions'

const Value = (props) => {
  const { getValuesAction, getValuesList, loading, error, messages } = props

  React.useEffect(() => {
    // alert('calld')
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  function fetchData() {
    getValuesAction(1);
  }
  const regex = /(<([^>]+)>)/ig;
  const secondRegEx = /((&nbsp;))*/gmi;
  const Main_title_detail = getValuesList[getValuesList.length - 1];

  return (
    <>
    { getValuesList.length > 0
      ?
    <section className="value-wrap">
      <Container>
        <Row>
          <Col md={6}>
            <div className="value-content-wrap">
              {/* <h2>Values</h2> */}
              <h1>{Main_title_detail.MainTitle} {Main_title_detail.SubTitle}</h1>
            </div>
          </Col>
        </Row>

        <div className="all-value-wrap">
          <Row>
          { getValuesList && getValuesList.slice(0,getValuesList.length - 1).map((item) => (
            <Col md={3}>
              <div className="all-value">
                <div className="icon">
                  <img src={`${our_value_image}/${item.Icon}`} alt="visionicon" />
                </div>
                <div className="title">{item.Title}</div>
                <p className="detail">
                {item.Content.replace(regex, '').replace(secondRegEx,'')}
                  <br />
                </p>
              </div>
            </Col>
          ))}  
          </Row>
        </div>
      </Container>
      
    </section>
    : <section>

      </section>
    }
    </>
  );
};

//   export default HowitWork;
const mapStateToProps = ({ values }) => { 
  // console.log('======', howitwork);
  const { loading, error, messages, getValuesList } = values;
  return { loading, error, messages, getValuesList };
};

export default connect(mapStateToProps, {
  getValuesAction: getValues,
})(Value);

